import { render, staticRenderFns } from "./AppDetailTab7.vue?vue&type=template&id=6373beff&scoped=true";
import script from "./AppDetailTab7.vue?vue&type=script&lang=js";
export * from "./AppDetailTab7.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab7.vue?vue&type=style&index=0&id=6373beff&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "6373beff", null);
export default component.exports;